const locale = {
  placeholder: 'Selezionare il tempo',
}

export default locale



// WEBPACK FOOTER //
// ./components/time-picker/locale/it_IT.js